import ApiService from "@/common/api.service"

export const PreserviceService = {
    async getPostServices(params) {
        const res = await ApiService.get(
            `/pre-services?${params}`
        );
        return res.data
    },

}